<template>
  <div class="swiper-container swiper-news-home">
    <div class="swiper-wrapper">
      <router-link :to="`/news_detail/${item.id}`" target="_blank" class="swiper-slide" v-for="(item, index) in newsSwipers" :key="index">
        <img :src="item.img" />
        <div class="swiper-text">
          {{ item.title }}
        </div>
      </router-link>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import Swiper, { Autoplay, Pagination } from "swiper";
Swiper.use([Autoplay, Pagination]);
import { post } from "@/util/http";

export default {
  name: "test",
  components: {},
  data() {
    return {
      newsSwipers: "",
    };
  },
  watch: {
    newsSwipers() {
      this.$nextTick(() => {
        new Swiper(".swiper-news-home", {
          loop: true,
          autoplay: {
            delay: 3000, //自动切换的时间间隔，单位ms
            stopOnLastSlide: false, //如果设置为true，当切换到最后一个slide时停止自动切换。
            disableOnInteraction: false, //用户操作swiper之后，是否禁止autoplay。
            reverseDirection: false, //开启反向自动轮播。
            waitForTransition: false, //等待过渡完毕。自动切换会在slide过渡完毕后才开始计时。
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
      });
    },
  },
  async mounted() {
    const {
      data: { data },
    } = await post({
      url: "/api/news/getNewsBannerList",
    });
    if (data.length > 6) {
      this.newsSwipers = data.slice(0, 6);
    } else {
      this.newsSwipers = data;
    }
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.swiper-pagination {
  width: 1.4rem !important;
  bottom: 0.26rem !important;
  left: 4.7rem !important;
}
.swiper-container {
  width: 6.18rem;
  border-radius: 0.1rem;
}
.swiper-text {
  background: linear-gradient(180deg, rgba(196, 196, 196, 0) 0%, #000000 100%);
  padding: 0 1.9rem 0 0.24rem;
  color: #fff;
  height: 1.05rem;
  line-height: 1.48rem;
  font-size: 0.18rem;
  width: 6.18rem;
  z-index: 5;
  position: absolute;
  bottom: 0;
  overflow: hidden;
}

img {
  width: 100%;
  height: 3.54rem;
  object-fit: cover;
}
</style>
